module.exports = __webpack_public_path__ + "static/img/mcspeed.32682ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/mcspeed.svg
// module id = ebkw
// module chunks = 0